import parse from 'html-react-parser';
import { reactToHTMLParseType } from '../types/customTypes';

interface StyleElement {
    element: string;
    color: string;
}

export const htmlReactParserWrapper = (html?: reactToHTMLParseType, styleElement?: StyleElement): reactToHTMLParseType => {
    if (html) {
        if (typeof html === 'string') {
            html = html?.replace(/<\/?p[^>]*>/g, '');
            if (styleElement) {
                html = parse(html, {
                    replace: (domNode) => {
                        if (domNode.name === styleElement.element) {
                            domNode.attribs.style = `color: ${styleElement.color}`;
                        }
                    },
                });
            } else {
                html = parse(html);
            }
        }
    } else {
        html = '';
    }
    return html;
};

export const parseHTML = (htmlString: string): string => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlString, 'text/html');
    return parsedHtml.body.textContent || '';
};

export const parseHtmlElementFromHtml = (htmlString: string, tagType: string): HTMLElement | null => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlString, 'text/html');
    return parsedHtml.querySelector(`${tagType}`);
};

export const extractParagraphs = (htmlString: string): string[] => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const paragraphs = doc.getElementsByTagName('p');
    const texts = Array.from(paragraphs).map((p) => p.textContent || '');
    return texts;
};

export const replaceParagraphElementWithClassName = (className: string, html?: reactToHTMLParseType): reactToHTMLParseType => {
    if (html) {
        const replaceTag = `<p className=${className}>`;
        if (typeof html === 'string') {
            html = html?.replace(/<p[^>]*>/g, replaceTag);
            html = parse(html);
        }
    } else {
        html = '';
    }
    return html;
};
